export function setupAutoPostback (elem) {
  const selects = elem.querySelectorAll('[data-auto-post]')

  for (const select of selects) {
    select.addEventListener('change', () => {
      const form = select.closest('form')
      if (form) {
        const ev = new Event('submit', { cancelable: true, bubbles: true })
        form.dispatchEvent(ev)
      }
    })
  }
}
